import React, { useState } from "react";
import matrixosLogo from "../assets/images/matrixos-logo-transparent.png";

const infoTabs = [
  { label: "About", href: "/about", kicker: "Platform overview" },
  { label: "Terms", href: "/terms", kicker: "Service rules" },
  { label: "Privacy", href: "/privacy", kicker: "Data protection" },
  { label: "Billing & Refunds", href: "/billing", kicker: "Payments" },
  { label: "Acceptable Use", href: "/acceptable-use", kicker: "Platform rules" },
  { label: "Data Processing", href: "/data-processing", kicker: "POPIA / GDPR" },
  { label: "FAQ", href: "/faq", kicker: "Quick answers" },
  { label: "Contact", href: "/contact", kicker: "Support & enquiries" },
];

const topLinks = [
  { label: "Neo", href: "/?home=1&layer=neo" },
  { label: "Morpheus", href: "/?home=1&layer=morpheus" },
  { label: "Link", href: "/?home=1&layer=link", soon: true },
  { label: "Matrix League", href: "/?home=1&layer=matrix-league" },
  { label: "Book a Discovery", href: "/discovery", primary: true },
  { label: "Sign in", href: "/login" },
];

function routeTo(path) {
  window.location.href = path;
}

function activeFor(pathname, href) {
  if (href === "/billing") return pathname === "/billing" || pathname === "/refunds";
  if (href === "/acceptable-use") return pathname === "/acceptable-use" || pathname === "/legal/acceptable-use";
  if (href === "/data-processing") return pathname === "/data-processing" || pathname === "/legal/data-processing";
  return pathname === href;
}

export default function MatrixOSInfoShell({
  eyebrow,
  title,
  subtitle,
  children,
  footerNote = "These pages are written for clarity and should be reviewed against your final commercial agreements before public launch.",
}) {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const [menuOpen, setMenuOpen] = useState(false);

  const navigateAndClose = (href) => {
    setMenuOpen(false);
    routeTo(href);
  };

  return (
    <div style={styles.page} className="matrixos-info-shell">
      <style>{`
        .matrixos-info-shell .matrixos-glow-card,
        .matrixos-info-shell .matrixos-side-tab,
        .matrixos-info-shell .matrixos-footer,
        .matrixos-info-shell .matrixos-footer-link,
        .matrixos-info-shell .matrixos-brand-pill,
        .matrixos-info-shell .matrixos-nav-link {
          transition: border-color 220ms ease, box-shadow 220ms ease, background 220ms ease, transform 220ms ease;
        }

        .matrixos-info-shell .matrixos-glow-card:hover,
        .matrixos-info-shell .matrixos-side-tab:hover,
        .matrixos-info-shell .matrixos-footer:hover {
          border-color: rgba(103,232,249,0.58) !important;
          box-shadow: 0 0 44px rgba(34,211,238,0.20), 0 24px 90px rgba(0,0,0,0.24) !important;
          background: linear-gradient(180deg, rgba(10,48,76,0.88) 0%, rgba(4,18,33,0.96) 100%) !important;
          transform: translateY(-1px);
        }

        .matrixos-info-shell .matrixos-footer-link:hover {
          border-color: rgba(103,232,249,0.62) !important;
          box-shadow: 0 0 34px rgba(34,211,238,0.20) !important;
          background: rgba(34,211,238,0.10) !important;
        }

        .matrixos-info-shell .matrixos-nav-link:not(.matrixos-nav-primary):hover {
          border-color: rgba(103,232,249,0.58) !important;
          box-shadow: 0 0 22px rgba(34,211,238,0.14) !important;
          background: rgba(16,53,77,0.92) !important;
          color: #ffffff !important;
        }

        .matrixos-info-shell .matrixos-nav-primary:hover {
          border-color: rgba(125,238,255,0.95) !important;
          background: linear-gradient(180deg, #86efff 0%, #35cce8 100%) !important;
          box-shadow: 0 0 34px rgba(34,211,238,0.34) !important;
          transform: translateY(-1px);
        }

        .matrixos-info-shell .matrixos-brand-pill:hover {
          background: transparent !important;
          border-color: transparent !important;
          box-shadow: none !important;
          transform: translateY(-1px);
        }


        .matrixos-info-shell .matrixos-home-footer {
          position: relative;
          background: #020b15;
          border-top: 1px solid rgba(62, 151, 225, .16);
          padding: 28px clamp(20px, 4vw, 64px) 30px;
          color: #8fa6ba;
        }
        .matrixos-info-shell .matrixos-home-footer-inner {
          width: min(1480px, 100%);
          margin: 0 auto;
          display: grid;
          grid-template-columns: minmax(260px, 1fr) auto minmax(260px, 1fr);
          align-items: center;
          gap: 28px;
        }
        .matrixos-info-shell .matrixos-home-footer-brand {
          display: flex;
          align-items: center;
          gap: 14px;
          min-width: 0;
        }
        .matrixos-info-shell .matrixos-home-footer-brand div { display: grid; gap: 2px; }
        .matrixos-info-shell .matrixos-home-footer-brand strong {
          color: #f6fbff; font-size: .96rem; letter-spacing: .01em;
        }
        .matrixos-info-shell .matrixos-home-footer-brand span {
          color: #6f8aa2; font-size: .78rem;
        }
        .matrixos-info-shell .matrixos-home-footer-brand small {
          color: #536f86; font-size: .72rem; line-height: 1.45; font-weight: 600;
        }
        .matrixos-info-shell .matrixos-home-footer-links {
          display: flex; align-items: center; justify-content: center; gap: 26px;
        }
        .matrixos-info-shell .matrixos-home-footer-links a {
          color: #9fb3c5; text-decoration: none; font-size: .88rem; font-weight: 700; transition: color .2s ease;
        }
        .matrixos-info-shell .matrixos-home-footer-links a:hover { color: #34b9ff; }
        .matrixos-info-shell .matrixos-home-footer-legal {
          display: flex; justify-content: flex-end; text-align: right; font-size: .8rem; color: #647d93;
        }
        @media (max-width: 980px) {
          .matrixos-info-shell .matrixos-home-footer-inner { grid-template-columns: 1fr auto; }
          .matrixos-info-shell .matrixos-home-footer-links { justify-content: flex-end; }
          .matrixos-info-shell .matrixos-home-footer-legal {
            grid-column: 1 / -1; justify-content: flex-start; text-align: left; padding-top: 14px;
            border-top: 1px solid rgba(62, 151, 225, .11);
          }
        }


        .matrixos-info-shell .matrixos-nav-link .matrixos-soon-badge {
          margin-left: 5px;
          padding: 2px 6px;
          border: 1px solid rgba(56,189,248,.38);
          border-radius: 999px;
          color: #67e8f9;
          font-size: .58rem;
          font-weight: 800;
          letter-spacing: .08em;
          text-transform: uppercase;
          line-height: 1.2;
        }
        .matrixos-info-shell .matrixos-info-menu-toggle,
        .matrixos-info-shell .matrixos-info-mobile-menu { display: none; }
        .matrixos-info-shell .matrixos-info-menu-backdrop { display: none; }

        @media (max-width: 760px) {
          .matrixos-info-shell {
            overflow-x: hidden !important;
            overflow-y: auto !important;
          }
          .matrixos-info-shell .matrixos-info-top-nav {
            width: calc(100% - 28px) !important;
            padding-top: 18px !important;
            justify-content: center !important;
            gap: 14px !important;
          }
          .matrixos-info-shell .matrixos-info-brand-logo {
            width: min(250px, 82vw) !important;
          }
          .matrixos-info-shell .matrixos-info-link-row { display: none !important; }
          .matrixos-info-shell .matrixos-info-top-nav {
            justify-content: space-between !important;
            align-items: center !important;
          }
          .matrixos-info-shell .matrixos-info-brand-logo {
            width: min(185px, 58vw) !important;
          }
          .matrixos-info-shell .matrixos-info-menu-toggle {
            display: inline-flex !important;
            width: 44px;
            height: 44px;
            align-items: center;
            justify-content: center;
            border-radius: 12px;
            border: 1px solid rgba(76,169,235,.34);
            background: rgba(7,26,44,.94);
            color: #eff8ff;
            font-size: 1.55rem;
            cursor: pointer;
          }
          .matrixos-info-shell .matrixos-info-menu-backdrop {
            display: block;
            position: fixed;
            inset: 0;
            z-index: 18;
            border: 0;
            padding: 0;
            margin: 0;
            background: rgba(0, 7, 16, .34);
          }
          .matrixos-info-shell .matrixos-info-top-nav { position: relative !important; z-index: 20 !important; }
          .matrixos-info-shell .matrixos-info-menu-toggle { position: relative; z-index: 22; }
          .matrixos-info-shell .matrixos-info-mobile-menu {
            display: none;
            width: calc(100% - 28px);
            margin: 8px auto 0;
            padding: 10px;
            border: 1px solid rgba(76,169,235,.28);
            border-radius: 18px;
            position: relative;
            z-index: 21;
            background: #061a2b;
            box-shadow: 0 22px 50px rgba(0,0,0,.48), 0 0 0 1px rgba(57,201,255,.05);
          }
          .matrixos-info-shell .matrixos-info-mobile-menu.is-open { display: grid; gap: 8px; }
          .matrixos-info-shell .matrixos-info-mobile-menu button {
            width: 100%;
            min-height: 44px;
            padding: 10px 14px;
            border: 1px solid rgba(76,169,235,.20);
            border-radius: 12px;
            background: rgba(14,48,76,.96);
            color: #f7fbff;
            opacity: 1;
            font-weight: 760;
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
          }
          .matrixos-info-shell .matrixos-info-mobile-menu button.is-primary {
            justify-content: center;
            color: #fff;
            border-color: rgba(66,185,255,.42);
            background: linear-gradient(180deg,#18c8ff 0%,#0879f5 100%);
          }
          .matrixos-info-shell .matrixos-info-main {
            width: calc(100% - 28px) !important;
            margin-top: 24px !important;
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 16px !important;
            padding-bottom: 32px !important;
          }
          .matrixos-info-shell .matrixos-info-side-nav {
            position: relative !important;
            top: auto !important;
            border-radius: 24px !important;
            padding: 14px !important;
            display: grid !important;
            grid-template-columns: 1fr !important;
          }
          .matrixos-info-shell .matrixos-side-tab {
            width: 100% !important;
            padding: 16px !important;
            border-radius: 18px !important;
          }
          .matrixos-info-shell .matrixos-glow-card {
            border-radius: 24px !important;
            padding: 24px 20px !important;
          }
          .matrixos-info-shell .matrixos-info-title {
            font-size: clamp(2.2rem, 13vw, 3.2rem) !important;
            line-height: 1 !important;
          }
          .matrixos-info-shell .matrixos-info-subtitle {
            font-size: 1rem !important;
            line-height: 1.65 !important;
          }
          .matrixos-info-shell .matrixos-info-content-wrap {
            width: 100% !important;
            max-width: 100% !important;
            overflow-x: hidden !important;
          }
          .matrixos-info-shell .matrixos-home-footer { padding: 26px 18px 28px; }
          .matrixos-info-shell .matrixos-home-footer-inner { grid-template-columns: 1fr; gap: 20px; }
          .matrixos-info-shell .matrixos-home-footer-links { justify-content: flex-start; gap: 22px; flex-wrap: wrap; }
          .matrixos-info-shell .matrixos-home-footer-legal { grid-column: 1; padding-top: 18px; }
          .matrixos-info-shell .matrixos-info-footer {
            width: calc(100% - 28px) !important;
            justify-content: center !important;
            text-align: center !important;
          }
          .matrixos-info-shell .matrixos-info-footer-links {
            justify-content: center !important;
          }
        }
      `}</style>
      <div style={styles.glow} />
      <div style={styles.grid} />
      <div style={styles.vignette} />
      <div style={styles.orbOne} />
      <div style={styles.orbTwo} />

      <header style={styles.topNav} className="matrixos-info-top-nav">
        <button type="button" className="matrixos-brand-pill" style={styles.brandPill} onClick={() => routeTo("/")} aria-label="Go to MatrixOS home">
          <img src={matrixosLogo} alt="MatrixOS" style={styles.brandLogo} className="matrixos-info-brand-logo" />
        </button>

        <nav style={styles.linkRow} className="matrixos-info-link-row">
          {topLinks.map((link) => (
            <button
              key={link.label}
              type="button"
              className={`matrixos-nav-link${link.primary ? " matrixos-nav-primary" : ""}`} style={link.primary ? styles.navPrimary : styles.navLink}
              onClick={() => routeTo(link.href)}
            >
              <span>{link.label}</span>
              {link.soon && <small className="matrixos-soon-badge">Soon</small>}
            </button>
          ))}
        </nav>
        <button
          type="button"
          className="matrixos-info-menu-toggle"
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? "×" : "☰"}
        </button>
      </header>

      {menuOpen && (
        <button
          type="button"
          className="matrixos-info-menu-backdrop"
          aria-label="Close navigation menu"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <div className={`matrixos-info-mobile-menu ${menuOpen ? "is-open" : ""}`}>
        {topLinks.map((link) => (
          <button
            key={link.label}
            type="button"
            className={link.primary ? "is-primary" : ""}
            onClick={() => navigateAndClose(link.href)}
          >
            <span>{link.label}</span>
            {link.soon && <small className="matrixos-soon-badge">Soon</small>}
          </button>
        ))}
      </div>

      <main style={styles.main} className="matrixos-info-main">
        <aside style={styles.sideNav} className="matrixos-info-side-nav">
          <div style={styles.sideLabel}>Legal / Support</div>
          {infoTabs.map((tab) => {
            const isActive = activeFor(pathname, tab.href);
            return (
              <button
                key={tab.href}
                type="button"
                onClick={() => routeTo(tab.href)}
                className="matrixos-side-tab"
                style={{
                  ...styles.sideTab,
                  ...(isActive ? styles.sideTabActive : {}),
                }}
              >
                <span style={styles.sideTabText}>{tab.label}</span>
                <span style={styles.sideTabKicker}>{tab.kicker}</span>
              </button>
            );
          })}
        </aside>

        <section style={styles.contentColumn}>
          <section className="matrixos-glow-card" style={styles.heroCard}>
            <div style={styles.eyebrow}>{eyebrow}</div>
            <h1 style={styles.title} className="matrixos-info-title">{title}</h1>
            <p style={styles.subtitle} className="matrixos-info-subtitle">{subtitle}</p>
          </section>

          <section style={styles.contentWrap} className="matrixos-info-content-wrap">{children}</section>

          <section className="matrixos-glow-card" style={styles.disclaimerCard}>
            <div style={styles.disclaimerTitle}>Plain-language note</div>
            <p style={styles.disclaimerBody}>{footerNote}</p>
          </section>
        </section>
      </main>

      <footer className="matrixos-home-footer" aria-label="MatrixOS footer">
        <div className="matrixos-home-footer-inner">
          <div className="matrixos-home-footer-brand">
            <div>
              <strong>MatrixOS</strong>
              <span>Operate with Clarity.</span>
              <small>Built in South Africa for multi-site operations.</small>
              <small>B-BBEE Level 1 Contributor · 135% B-BBEE procurement recognition.</small>
            </div>
          </div>

          <nav className="matrixos-home-footer-links" aria-label="Footer navigation">
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
            <a href="https://www.linkedin.com/company/112805381/" target="_blank" rel="noreferrer">LinkedIn ↗</a>
          </nav>

          <div className="matrixos-home-footer-legal">
            <span>© 2026 MatrixOS. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

const panel = {
  background: "linear-gradient(180deg, rgba(9,30,52,0.88) 0%, rgba(4,14,27,0.94) 100%)",
  border: "1px solid rgba(124, 234, 255, 0.16)",
  boxShadow: "0 28px 100px rgba(0,0,0,0.26)",
  backdropFilter: "blur(18px)",
};

const styles = {
  page: {
    minHeight: "100vh",
    position: "relative",
    overflowX: "hidden",
    overflowY: "auto",
    background:
      "radial-gradient(circle at 14% 10%, rgba(34,211,238,0.16), transparent 24%), radial-gradient(circle at 82% 18%, rgba(59,130,246,0.16), transparent 28%), linear-gradient(180deg, #031321 0%, #041425 58%, #020b16 100%)",
    color: "#effcff",
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  glow: {
    position: "absolute",
    inset: 0,
    background: "radial-gradient(circle at 50% 22%, rgba(42,184,255,0.12), transparent 48%)",
    pointerEvents: "none",
  },
  grid: {
    position: "absolute",
    inset: 0,
    backgroundImage:
      "linear-gradient(rgba(48,211,255,0.055) 1px, transparent 1px), linear-gradient(90deg, rgba(48,211,255,0.055) 1px, transparent 1px)",
    backgroundSize: "68px 68px",
    opacity: 0.34,
    pointerEvents: "none",
  },
  vignette: {
    position: "absolute",
    inset: 0,
    background: "radial-gradient(circle at center, transparent 0%, rgba(2,7,14,0.20) 42%, rgba(2,7,14,0.76) 100%)",
    pointerEvents: "none",
  },
  orbOne: {
    position: "absolute",
    width: 540,
    height: 540,
    borderRadius: "999px",
    border: "1px solid rgba(103,232,249,0.08)",
    left: "50%",
    top: 120,
    transform: "translateX(-50%)",
    boxShadow: "0 0 130px rgba(34,211,238,0.05)",
    pointerEvents: "none",
  },
  orbTwo: {
    position: "absolute",
    width: 2,
    height: 190,
    right: "9%",
    top: "32%",
    transform: "rotate(61deg)",
    background: "rgba(103,232,249,0.22)",
    filter: "blur(1px)",
    pointerEvents: "none",
  },
  topNav: {
    position: "relative",
    zIndex: 3,
    width: "min(1280px, calc(100% - 48px))",
    margin: "0 auto",
    padding: "28px 0 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 18,
    flexWrap: "wrap",
  },
  brandPill: {
    border: "1px solid transparent",
    background: "transparent",
    borderRadius: 0,
    padding: 0,
    cursor: "pointer",
    textAlign: "left",
    boxShadow: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 0,
    height: "auto",
    overflow: "visible",
  },
  brandLogo: {
    display: "block",
    width: 230,
    height: "auto",
    objectFit: "contain",
    filter: "drop-shadow(0 0 16px rgba(34,211,238,0.18))",
  },
  linkRow: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  navLink: {
    border: "1px solid rgba(148,210,235,0.24)",
    background: "rgba(7,28,47,0.72)",
    color: "#eafcff",
    borderRadius: 14,
    padding: "10px 15px",
    fontSize: "0.82rem",
    fontWeight: 800,
    letterSpacing: "0.02em",
    textTransform: "none",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  navPrimary: {
    border: "1px solid rgba(103,232,249,0.78)",
    background: "linear-gradient(180deg, #7cecff 0%, #58ddec 100%)",
    color: "#061421",
    borderRadius: 14,
    padding: "10px 17px",
    fontSize: "0.82rem",
    fontWeight: 900,
    letterSpacing: "0.02em",
    textTransform: "none",
    cursor: "pointer",
    whiteSpace: "nowrap",
    boxShadow: "0 0 28px rgba(34,211,238,0.24)",
  },
  main: {
    position: "relative",
    zIndex: 3,
    width: "min(1280px, calc(100% - 48px))",
    margin: "44px auto 0",
    display: "grid",
    gridTemplateColumns: "260px minmax(0, 1fr)",
    gap: 24,
    alignItems: "start",
    paddingBottom: 54,
  },
  sideNav: {
    ...panel,
    position: "sticky",
    top: 24,
    borderRadius: 30,
    padding: 18,
    display: "grid",
    gap: 10,
  },
  sideLabel: {
    color: "#a5f3fc",
    fontSize: "0.68rem",
    fontWeight: 950,
    letterSpacing: "0.28em",
    textTransform: "uppercase",
    margin: "6px 8px 8px",
  },
  sideTab: {
    border: "1px solid rgba(255,255,255,0.10)",
    background: "rgba(255,255,255,0.035)",
    color: "#eafcff",
    borderRadius: 20,
    padding: "14px 15px",
    textAlign: "left",
    cursor: "pointer",
    transition: "0.25s ease",
  },
  sideTabActive: {
    border: "1px solid rgba(103,232,249,0.60)",
    background: "linear-gradient(135deg, rgba(34,211,238,0.20), rgba(59,130,246,0.10))",
    boxShadow: "0 0 34px rgba(34,211,238,0.16)",
  },
  sideTabText: {
    display: "block",
    fontWeight: 950,
    fontSize: "0.98rem",
  },
  sideTabKicker: {
    display: "block",
    marginTop: 5,
    color: "rgba(213,245,255,0.70)",
    fontSize: "0.78rem",
  },
  contentColumn: {
    minWidth: 0,
  },
  heroCard: {
    ...panel,
    borderRadius: 34,
    padding: "42px 44px",
  },
  eyebrow: {
    color: "#8cefff",
    fontSize: "0.78rem",
    fontWeight: 950,
    letterSpacing: "0.32em",
    textTransform: "uppercase",
    marginBottom: 18,
  },
  title: {
    margin: 0,
    fontSize: "clamp(2.8rem, 5.8vw, 5.1rem)",
    lineHeight: 0.98,
    letterSpacing: "-0.06em",
    fontWeight: 950,
  },
  subtitle: {
    marginTop: 20,
    maxWidth: 920,
    color: "#d4eaf4",
    fontSize: "1.1rem",
    lineHeight: 1.75,
  },
  contentWrap: {
    marginTop: 22,
    display: "grid",
    gap: 18,
  },
  disclaimerCard: {
    marginTop: 22,
    border: "1px solid rgba(103,232,249,0.18)",
    background: "rgba(103,232,249,0.055)",
    borderRadius: 26,
    padding: "22px 24px",
  },
  disclaimerTitle: {
    color: "#a5f3fc",
    fontSize: "0.72rem",
    fontWeight: 950,
    letterSpacing: "0.28em",
    textTransform: "uppercase",
  },
  disclaimerBody: {
    margin: "10px 0 0",
    color: "#cfe8f4",
    lineHeight: 1.7,
  },
  footer: {
    position: "relative",
    zIndex: 3,
    width: "min(1280px, calc(100% - 48px))",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 18,
    flexWrap: "wrap",
    padding: "24px 0 28px",
    color: "rgba(196,230,242,0.72)",
    fontSize: "0.82rem",
  },
  footerBrand: {
    color: "#a5f3fc",
    fontWeight: 950,
    letterSpacing: "0.28em",
    textTransform: "uppercase",
  },
  footerCopy: {
    marginTop: 8,
  },
  footerSub: {
    marginTop: 4,
    textTransform: "uppercase",
    letterSpacing: "0.18em",
  },
  footerLinks: {
    display: "flex",
    gap: 9,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  footerLink: {
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.035)",
    color: "#dff8ff",
    borderRadius: 999,
    padding: "10px 13px",
    cursor: "pointer",
    fontSize: "0.68rem",
    fontWeight: 950,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
  },
};
